import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { change } from 'redux-form';

import PermissionCheckbox from './PermissionCheckbox';
import { withFormName } from '../hoc/withFormName';

export default compose(
  withFormName,
  connect(null, { change }),
  withHandlers({
    onChange: props => (e, newValue) => {
      if (newValue && props.requires && props.requires.length) {
        props.requires.forEach((permissionToTurnOn) => {
          props.change(props.form, permissionToTurnOn, true);
        });
      }
      if (!newValue && props.requiredFor && props.requiredFor.length) {
        props.requiredFor.forEach((permissionToTurnOff) => {
          props.change(props.form, permissionToTurnOff, false);
        });
      }
    },
  }),
)(PermissionCheckbox);
